// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Jybu","productName":"Table_productName__1dd7H"};